<template>
  <div id="account-opt-in" class="mt-8 pt-4">
    <h1 class="card-title mb-5">{{ $t('views.myAccount.optIn.title') }}</h1>

    <div class="items-flex">
      <h2 class="mr-2">{{ $t('views.myAccount.optIn.emailMarketing.label') }}</h2>
      <InfoIcon :size="15" :text="$t(`views.myAccount.optIn.emailMarketing.info`)" />
      <v-switch
        v-model="optInEmailMarketing"
        class="ml-5 my-0 py-0"
        :loading="loadingOptInEmailMarketing"
        :disabled="errorOptInEmailMarketing"
        hide-details
        @change="updateOptInEmailMarketing"
      ></v-switch>
    </div>
    <div class="items-flex pt-5">
      <h2 class="mr-2">{{ $t('views.myAccount.optIn.tutorial.label') }}</h2>
      <InfoIcon :size="15" :text="$t(`views.myAccount.optIn.tutorial.info`)" />
      <v-switch
        v-model="myUser.preferences.optInTutorial"
        class="ml-5 my-0 py-0"
        :loading="loading"
        hide-details
        @change="$emit('updateUserPreferences')"
      ></v-switch>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUserOptIn, updateUserOptIn } from '@/lib/api.js'
import InfoIcon from '@/views/components/common/InfoIcon'

export default {
  components: {
    InfoIcon,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    myUser: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      loadingOptInEmailMarketing: false,
      optInEmailMarketing: false,
      errorOptInEmailMarketing: false,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.loadOptIn()
  },
  methods: {
    async loadOptIn() {
      this.loadingOptInEmailMarketing = true
      try {
        const userOptIn = await getUserOptIn({ uid: this.user.uid })
        this.optInEmailMarketing = userOptIn.data.emailMarketing
      } catch (error) {
        this.errorOptInEmailMarketing = true
      }
      this.loadingOptInEmailMarketing = false
    },
    async updateOptInEmailMarketing(status) {
      this.loadingOptInEmailMarketing = true
      try {
        await updateUserOptIn({
          uid: this.user.uid,
          data: {
            emailMarketing: status,
          },
        })
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loadingOptInEmailMarketing = false
      this.loadOptIn()
    },
  },
}
</script>

<style></style>
